import { render, staticRenderFns } from "./DashboardGraduatePlacementItem.vue?vue&type=template&id=8fcacff8&"
import script from "./DashboardGraduatePlacementItem.vue?vue&type=script&lang=js&"
export * from "./DashboardGraduatePlacementItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports